// extracted by mini-css-extract-plugin
export default {"dragzone":"FileUploader_dragzone__-4763","dragging":"FileUploader_dragging__2XGXC","buttonWrapper":"FileUploader_buttonWrapper__Mg7gN"};